/**
 * The stone answer as a new delivery sends it. `noteSuffix` is appended to the note staff read,
 * for a surface that also quoted the customer a price.
 */
export function buildStoneRequest(mode, selectedItemIndexes, noteSuffix) {
    const specific = mode === "SPECIFIC";
    const note = "Kunden ønsker skånsom gullsmed-fjerning på spesifiserte gjenstander.";
    return {
        stoneHandling: specific ? "REMOVE_AND_RETURN" : "KEEP_AS_IS",
        stoneHandlingDetails: {
            mode,
            selectedItemIndexes: specific ? selectedItemIndexes : [],
            removalMethod: specific ? "GOLDSMITH" : null,
            note: specific ? (noteSuffix ? `${note} ${noteSuffix}` : note) : null,
        },
    };
}
